<template>
  <el-dialog :visible.sync="visible" :title="this.dataForm.studentName+'('+this.className+')'" :close-on-click-modal="false" :close-on-press-escape="false">
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-assessment__trainevaluatescore">
      <el-form :inline="true"  @keyup.enter.native="getDataList()" style="align-items: center;display: flex">
      </el-form>
      <h3 style="display: inline-block;margin-right: 8px">评价细则总数：{{ruleForm.ruleNumber}} 达标数{{ruleForm.getRuleNumber}}</h3>
      <el-card v-for="(medal,index) in medalList" :key="medal.id">
        <div slot="header" class="clearfix">
          <span>{{index + 1}} {{medal.medalName}}</span>
        </div>
        <el-form
                :model="medal"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmitHandle()"
                :label-width="'120px'"
        >
          <el-row v-for="(rule,index1) in medal.ruleList" :key="rule.id">
            <el-col :span="16">
              <el-form-item :label="index1+1+'.'" prop="studentName" label-width="50px" style="border: none">
                <el-input readonly class="notBorder" v-model.trim="rule.medalRuleName" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" prop="">
                <el-select  class="el-select" @change="dataFormSubmitHandle(medal,rule)" v-model="rule.isResult">
                  <el-option label="达标" :value="1"></el-option>
                  <el-option label="未达标" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </el-card>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      medalList: [],
      visible: false,
      classId: '',
      className: '',
      studentId: '',
      studentName: '',
      ruleForm: {
        ruleNumber: '',
        getRuleNumber: ''
      },
      dataForm: {
        id: '',
        studentId: '',
        studentName: '',
        medalId: '',
        medalName: '',
        medalRuleId: '',
        medalRuleName: '',
        schoolYearId: '',
        schoolYearName: '',
        isPass: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: ''
      }
    }
  },
  watch: {},
  created () {
  },
  methods: {
    init () {
      this.visible = true
      console.log(this.dataForm)
      this.getMedalRuleList()
      this.getMedalRuleDetail()
      this.$nextTick(() => {
      })
    },
    // 获取信息
    getMedalRuleList (row) {
      this.$http.get('/medal/medal/getMedalRuleList', { params: { classId: this.classId, studentId: this.dataForm.studentId } }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.medalList = res.data
      }).catch(() => {})
    },
    // 获取信息
    getMedalRuleDetail (row) {
      this.$http.get('/medal/studentMedal/getMedalRuleDetail', { params: { classId: this.classId, studentId: this.dataForm.studentId } }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.ruleForm = res.data
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function (medal, rule) {
      console.log(medal)
      console.log(rule)
      this.dataForm.medalId = medal.id
      this.dataForm.medalName = medal.medalName
      this.dataForm.medalRuleId = rule.id
      this.dataForm.medalRuleName = rule.medalRuleName
      this.dataForm.isPass = rule.isResult
      this.$http.post('/medal/studentRule/', this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('已保存并重新计算该学生规则'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.$emit('refreshDataList')
          }
        })
      }).catch(() => {})
    }, 1000, { leading: true, trailing: false })
  },
  components: {
    // AddOrUpdate
  }
}
</script>
<style lang="scss">
  .notBorder{
    .el-input__inner {
      border: none;
    }
  };

</style>
